import Api from '@/services/api';

export default {
  accept(reservationAlterationId) {
    return Api()
      .post(`/reservation-alteration/${reservationAlterationId}/accept`)
      .then((res) => res.data);
  },
  decline(reservationAlterationId) {
    return Api()
      .post(`/reservation-alteration/${reservationAlterationId}/decline`)
      .then((res) => res.data);
  },
};
